import RadialProgressBar from 'vue-radial-progress';

if($('#component-application-score').length){
    var app = new Vue({
        el: '#component-application-score',
        data: {
            score:score,
            completedSteps:Math.round(score),
            radialColour:'#e20d0d',
            radialWidth:7,
            radialInnerColor:'#1F282F',
            totalSteps: 100,
        },
        mounted () {
            if (this.completedSteps >= 75 && this.completedSteps <= 100) {
                this.radialColour = '#2dcc70';
            } else if (this.completedSteps >= 30 && this.completedSteps <= 74) {
                this.radialColour = '#f8a01c';
            }
        },
        components: {
            'RadialProgressBar': RadialProgressBar
        }
    });
}